import React, {forwardRef}  from 'react';
import PropTypes from 'prop-types';
import ModalTemplate from "../../Wrappers/ModalTemplate";

const CalculationModal = forwardRef((props, ref) => {
  const {children} = props

  // Nota: crear un modal por cada tipo de cálculo

  // Íconos de operaciones
  // + plus
  // - minus
  // x cross
  // Caso de uso en <DaytimeHoursModal />

  return (
    <ModalTemplate
      ref={ref}
      className="calculation-modal"
    >
      {children}
    </ModalTemplate>
  );
})

CalculationModal.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CalculationModal;
